import { Loader } from 'semantic-ui-react';

export default function LoaderInsideButton() {
	return (
		<span style={{ marginLeft: '0.5rem' }}>
			<Loader inline active size="mini" />
		</span>
	);
}
